// extracted by mini-css-extract-plugin
export var label = "_kd-0";
export var treatmentCard = "_kd-1";